module.exports = __webpack_public_path__ + "assets/img/front.b0a05e75.png";